import { render, staticRenderFns } from "./ZArrowBold.vue?vue&type=template&id=28beb419&scoped=true"
import script from "./ZArrowBold.vue?vue&type=script&lang=js"
export * from "./ZArrowBold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28beb419",
  null
  
)

export default component.exports